import Image from "next/image";
import PeterTomWhiteboard from "public/assets/documentary/peter-tom-whiteboard.jpeg";
import Button from "components/library/Button";
import { ExternalLinkIcon } from "@heroicons/react/outline";
import { CAREERS_LINK } from "utils/constants";

const JoinUsSection = () => (
  <div className="py-48 sm:py-40">
    <div className="container-xl">
      <div className="grid items-center gap-x-48 md:grid-cols-2 md:pl-120">
        <div className="mb-48 md:mb-0">
          <div className="mb-12 text-14-24 text-gray-600 sm:text-18-28">
            Join us
          </div>
          <div className="max-w-[291px] font-display text-24-32 text-gray-900 sm:max-w-[469px] sm:text-[56px] sm:leading-[56px]">
            Help us build the world&apos;s most collaborative AI
          </div>
          <div className="mt-32 text-14-22 text-gray-800 sm:max-w-[346px] sm:text-14-24">
            We believe that the reason we&apos;ll succeed is because we&apos;re
            committed to learning and growing as quickly as possible. We know
            there&apos;s lots we don&apos;t know. What we&apos;re doing is
            fundamentally new and will require overcoming many hurdles. This
            excites us. If this excites you, join us.
          </div>
          <Button
            className="mt-32"
            IconRight={ExternalLinkIcon}
            href={CAREERS_LINK}
          >
            View open positions
          </Button>
        </div>
        <div className="relative hidden min-h-[240px] w-full md:block md:aspect-square">
          <WhiteboardImage />
        </div>
      </div>
    </div>

    <div className="relative min-h-[240px] md:hidden">
      <WhiteboardImage />
    </div>
  </div>
);

const WhiteboardImage = () => (
  <Image
    className="-scale-x-100 contrast-125 grayscale"
    src={PeterTomWhiteboard}
    alt=""
    layout="fill"
    objectFit="cover"
    objectPosition="50% 25%"
  />
);

export default JoinUsSection;
